import { functions, database } from './firebase';
import { httpsCallable } from 'firebase/functions';
import { ref, get } from 'firebase/database';

class InventoryService {
    constructor() {
        this.cache = null;
        this.lastFetch = null;
        this.CACHE_DURATION = 1000 * 60 * 15; // 15 minutes
    }

    async getInventory(force = false) {
        const now = Date.now();

        // 1. Memory Cache (Fastest)
        if (!force && this.cache && this.lastFetch && (now - this.lastFetch < this.CACHE_DURATION)) {
            console.log('[InventoryService] ⚡ Returning memory cached inventory');
            return this.cache;
        }

        // 2. RTDB Cache (Fast) - BUFFER STRATEGY
        if (!force) {
            try {
                console.log('[InventoryService] 🔍 Checking Realtime Database buffer...');
                const inventoryRef = ref(database, 'inventory/latest');
                const snapshot = await get(inventoryRef);

                if (snapshot.exists()) {
                    const data = snapshot.val();
                    if (data.items && Array.isArray(data.items) && data.items.length > 0) {
                        console.log(`[InventoryService] ✅ Loaded ${data.items.length} items from RTDB Buffer`);

                        // Update memory cache
                        this.cache = data.items;
                        this.lastFetch = now;

                        // Optional: Check if cache is stale (e.g., > 1 hour) and trigger background refresh
                        // For now, we return immediately as requested for speed.
                        return this.cache;
                    }
                }
            } catch (rtdbError) {
                console.warn("[InventoryService] ⚠️ Could not read RTDB buffer, falling back to API:", rtdbError);
            }
        }

        // 3. Cloud Function (Slow - Source of Truth)
        try {
            console.log('[InventoryService] ☁️ Fetching fresh inventory from Cloud Function (Dynamia API)...');
            const fetchInventoryFn = httpsCallable(functions, 'fetchInventory', { timeout: 120000 });
            const result = await fetchInventoryFn();

            if (result.data && result.data.items) {
                this.cache = result.data.items;
                this.lastFetch = now;
                console.log(`[InventoryService] ✅ Loaded ${this.cache.length} items from Cloud Function`);
                return this.cache;
            } else {
                throw new Error("Invalid structure from Cloud Function");
            }
        } catch (error) {
            console.error("❌ Cloud Function failed:", error);
            // If we failed here and didn't return RTDB earlier (because of Force or empty), attempt RTDB fallback one last time if not tried
            if (force) {
                try {
                    const inventoryRef = ref(database, 'inventory/latest');
                    const snapshot = await get(inventoryRef);
                    if (snapshot.exists()) return snapshot.val().items || [];
                } catch (e) { /* ignore */ }
            }
            throw new Error('No se pudo cargar el inventario. Por favor intenta de nuevo.');
        }
    }

    clearCache() {
        this.cache = null;
        this.lastFetch = null;
    }
}

export const inventoryService = new InventoryService();
